import type { ReactNode } from 'react'
import { ThemeProvider } from '@/clientWeb/contexts/ThemeContext'
import { LanguageProvider } from '@/clientWeb/i18n/LanguageContext'
import { HeaderProvider } from '@/clientWeb/contexts/HeaderContext'

interface AppProvidersProps {
  children: ReactNode
}

export default function AppProviders({ children }: AppProvidersProps) {
  return (
    <HeaderProvider>
      <ThemeProvider>
        <LanguageProvider>{children}</LanguageProvider>
      </ThemeProvider>
    </HeaderProvider>
  )
}
